/**
 * 간주 출근 문구 — 서버 `modules/hr/deemed-attendance.ts` 와 **같은 말**을 쓴다 (근태 D2, 2026-08-24).
 *
 * 승인된 출장·외근일은 출근한 것으로 본다. 화면은 그날 **왜 출근으로 보는지**를 늘 밝혀야 한다 —
 * 근거 없이 결근이 지워지면 판정을 신뢰할 수 없다.
 */

export const DEEMED_KIND_LABEL: Record<'business_trip' | 'outside_work', string> = {
  business_trip: '출장',
  outside_work: '외근',
};
